import React, {Component} from "react";
import Notify from "react-notification-alert";
import {request} from "../../../helper/APIUtils";
import {Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import Select from "../../../local_node_modules/react-select";
import Alert from "react-s-alert";
import {showAxiosError} from "../../../helper/helper";
import {defterUnitName, defterUnitNameShort} from "../../../helper/permission";
import {EntegratorConf} from "../../../constants";

class PriceListModal extends Component {
    constructor(props) {
        super(props);
        this.state =
            {
                quantityList: [],
                priceList: [],
                distributorPurchase: {
                    unit: 0,
                    startDate: "",
                    expireDate: "",
                    quantity: 0,
                    price: 0
                }
            };
        this.fetch = this.fetch.bind(this);
        this.unitTypeList = this.unitTypeList.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onSave = this.onSave.bind(this);
        this.validateFields = this.validateFields.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        let self = this;
        let params = {
            url: '/customer/fetchPriceList',
            method: "get"
        };

        self.setState({loading: true});
        request(params)
        .then(function (response) {
            self.setState({
                content: response.data,
                loading: false,
            });
        }).catch(function (error) {
            self.setState({loading: false});
        });
    }

    onSelect(field, selected) {

        let {distributorPurchase} = this.state;
        let quantityList = [];
        let priceList = [];

        if (field === "unit") {
            distributorPurchase["price"] = null;
            distributorPurchase["quantity"] = null;
            distributorPurchase["unit"] = selected;
            this.state.content.map((val) => {
                    if (val.unit === selected) {
                        priceList.push({value: val.price, label: val.price})
                        quantityList.push({value: val.quantity, label: val.quantity});
                    }
                }
            );
            this.setState({priceList, quantityList});
        }

        if (field === "quantity") {
            distributorPurchase["quantity"] = selected;
            this.state.content.map((val) => {
                    if (val.unit === distributorPurchase["unit"] &&
                        val.quantity === distributorPurchase["quantity"]) {
                        distributorPurchase["price"] =  val.price;
                    }
                    if (val.unit === distributorPurchase["unit"] &&
                        val.quantity === distributorPurchase["quantity"] &&
                        val.price === distributorPurchase["price"]) {
                        distributorPurchase["startDate"] = val.startDate;
                        distributorPurchase["expireDate"] = val.expireDate;
                    }
                }
            )
        }
        this.setState({distributorPurchase})
    }

    unitTypeList() {
        return [
            {value: 0, label: "Seçiniz..."},
            {value: 1, label: "Kontör"},
            {value: 2, label: defterUnitName(EntegratorConf.identifier)},
            {value: 3, label: "Arşiv Kasa"}
        ]
    }

    unitTypeExpr(unitType) {
        return (unitType === 1 || unitType === 3) ? "Adet" : (defterUnitNameShort(EntegratorConf.identifier))
    }

    validateFields() {
        let errorMessage = "";
        let {distributorPurchase} = this.state;
        if(distributorPurchase["unit"] === 0 || distributorPurchase["unit"] === null){
            errorMessage += "<strong>" + ("Birim Türü alanı boş bırakalamaz.") + "</strong><br/>";
        }
        if(distributorPurchase["price"] === 0 || distributorPurchase["price"] === null){
            errorMessage += "<strong>" + ("Fiyat alanı boş bırakalamaz." ) + "</strong><br/>";
        }
        if(distributorPurchase["quantity"] === 0 || distributorPurchase["quantity"] === null){
            errorMessage += "<strong>" + ("Birim Miktarı alanı boş bırakalamaz.") + "</strong><br/>";
        }
        return errorMessage;
    }

    onSave(){
        let errorMessage = this.validateFields();
        if(errorMessage !== ""){
            Alert.error(errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }else{
            let {distributorPurchase} = this.state;
            let merchantOkUrl    = window.location.origin;
            let recordId = null;
            this.state.content.map((val) => {
                if (val.unit === distributorPurchase["unit"] &&
                    val.price === distributorPurchase["price"] &&
                    val.quantity === distributorPurchase["quantity"]) {
                    recordId = val.recordId;
                }
            });
            let self = this;
            let params = {
                url:"/customer/setDistributorPurchase",
                method: "post",
                data: {
                    recordId,
                    merchantOkUrl
                }
            };
            self.setState({loading: true});
            request(params)
                .then(function (response) {
                    let order = response.data;
                    Alert.success("Sepete eklendi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000,
                        html:false
                    });
                    self.setState({loading: false});
                    setTimeout(function () {
                        self.setState({loading:false});
                        window.location.href = self.props.paytrDomain + "/external/" +order.merchantOid;
                    }, 100);
                }).catch(function (error) {
                showAxiosError(error);
            }).then(function () {
                self.setState({saveLoading: false});
            });
        }
    }



    render() {
        let {unit,quantity,price} = this.state.distributorPurchase;
        return (
            <Modal isOpen={this.props.isOpen} keyboard={true} size="lg">
                <Notify ref="notify"/>
                <ModalHeader toggle={this.props.toggle}>Kredi Yükle</ModalHeader>
                <ModalBody>
                    <Form>
                        <hr style={{"color": "aliceblue"}}/>
                        <Row form="true">
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="unit">Birim Türü</Label>
                                    <Select id="unit"
                                            name="unit"
                                            value={unit}
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => this.onSelect("unit", e.value)}
                                            options={this.unitTypeList()}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="quantity">Birim Miktarı <span
                                        style={{color: "crimson"}}>({this.unitTypeExpr(unit)})</span> </Label>
                                    <Select id="quantity"
                                            name="quantity"
                                            value={quantity}
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => this.onSelect("quantity", e.value)}
                                            options={this.state.quantityList}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form="true">
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="price">Fiyat (₺)</Label>
                                    <Select id="price"
                                            name="price"
                                            value={price}
                                            clearable={false}
                                            disabled={true}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => this.onSelect("price", e.value)}
                                            options={this.state.priceList}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <button type="button" onClick={this.props.toggle}
                            className=" TekBtn vazgec" style={{
                        background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                        padding: '9px 45px 9px 20px'
                    }}>Vazgeç
                    </button>
                    <div className="col-sm-6"></div>
                     <button type="button" onClick={this.onSave} style={{padding: '9px 45px 9px 20px'}}
                            disabled={this.state.loading} className="  TekBtn kaydet pull-right"
                    >Yükle
                    </button>
                </ModalFooter>
            </Modal>
        )
    }

}


export default PriceListModal;